// Seo Data Starts Here
export const seoStepData = [
  {
    icon: <i class="fas fa-chart-line"></i>,
    title: "Competitor Analysis",
    para: "We study what your competitors are doing and come up with a strategy to get better results. This analysis helps us figure out the best plan to improve your website's SEO.",
  },
  {
    icon: <i class="fas fa-search"></i>,
    title: "Keyword Research & Strategy",
    para: "ROZISOFT is an SEO company that specializes in your business area. We identify the best keywords to help you reach your goals. We conduct research to find keywords that are most relevant to your services and products, ensuring you attract the right organic traffic.",
  },
  {
    icon: <i class="fas fa-link"></i>,
    title: "Link Building",
    para: "Backlinks are essential for making your website rank higher in search engines. To do this effectively, you need a well-thought-out strategy, and that's where the SEO agency in Pakistan comes in. Our dedicated team specializes in building high-quality backlinks, enhancing your website's profile.",
  },
  {
    icon: <i class="fas fa-cogs"></i>,
    title: "Technical SEO",
    para: "Enhancing the technical aspects of your website, such as optimizing website loading speed and addressing development-related issues, can significantly enhance the overall user experience. When your website visitors are satisfied, you can be confident that your rankings will also bring you satisfaction.",
  },
  {
    icon: <i class="fas fa-search-location"></i>,
    title: "Local SEO",
    para: "If you operate a local business and aim to expand your online visibility and boost your local customer base, we strongly recommend considering our Google My Business Optimization service. After we optimize your GMB profile, you'll witness a remarkable surge in your local SEO rankings like never before.",
  },
  {
    icon: <i class="fas fa-file"></i>,
    title: "On-Page SEO",
    para: "At ROZISOFT, our primary focus is on enhancing your online presence and increasing organic traffic through well-planned on-page SEO techniques. We understand the specific requirements of your business growth, and our strategies are tailored to that goal. Our approach to enhancing your online visibility includes creating top-notch content, optimizing your meta tags and headings structure, and improving your website's loading speed.",
  },
  {
    icon: <i class="fas fa-file"></i>,
    title: "Of-Page SEO",
    para: "In order to elevate your SEO rankings and drive more traffic, we implement our off-page strategies to ensure your website acquires high-quality, active backlinks from other websites. Off-page SEO is a pivotal component for expanding your online visibility, and our team possesses specialized expertise in this field.",
  },
  {
    icon: <i class="fas fa-pencil-alt"></i>,
    title: "Content Writing",
    para: "At ROZISOFT, we boast a dedicated content writing department focused on creating high-quality, SEO-friendly, and purposeful content for your website. Whether you require optimization of existing content or fresh blog posts, our proficient content writing team is equipped to meet all your needs.",
  },
  {
    icon: <i class="fas fa-tachometer-average"></i>,
    title: "Conversion Rate Optimization (CRO):",
    para: "Our conversion rate optimization specialist employs Search Engine Optimization services to inspect and enhance the web pages of your website, as well as your landing pages. This plays a pivotal role in elevating the conversion rate of your web content, facilitating customer contact and inquiries.",
  },
];
export const pointsSeo = [
  {
    title: '1. Search ability Check Of The Website',
    description: 'Initially, we commence a technical website audit to assess its search engine performance. This entails verifying proper indexing on Google, identifying and rectifying any irrelevant indexed links, and addressing pages that may return a 404 error. Additionally, we scrutinize the websites robots file to ascertain if any pages are inaccessible to web crawlers. In the next step, we ensure the correct inclusion of the sitemap on the website.',
  },
  {
    title: '2. Website Speed Checker',
    description: 'The subsequent phase of our technical audit involves assessing the websites performance, with a focus on its speed and related elements, including the minification of JS and CSS files and the presence of excessive inline CSS. Our objective is to determine if the website attains the desired speed performance on both mobile devices and desktops. Ensuring compliance with the core web vitals test is of paramount significance, as Googles significant core updates have had a notable impact on the rankings of many websites in search engine results pages (SERPs).',
  },
  {
    title: '3.  Overall Website & URL Structure Check',
    description: `Next, we evaluate the website's overall structure, examining design adherence to search engine guidelines, user-friendliness, page presentation, and navigation ease. Additionally, we scrutinize the URL structure, ensuring SEO-friendly URLs that incorporate real words, facilitating improved rankings and crawler accessibility based on URLs alone.`,
  },
  {
    title: '4. Complete On Page, Meta Title Description, Images & Content Checker',
    description: `After completing the technical assessments, we transition to evaluating the website's on-page SEO performance. This includes analyzing the optimization of meta titles and descriptions, assessing the heading hierarchy within the content, and examining the effective utilization of H tags. We also review keyword distribution, considering the integration of long-tailed keywords, synonyms, and LSI keywords. Our focus is on ensuring that the content aligns with the intended audience's needs and offers value. Equally crucial, we verify the originality of the content to prevent plagiarism issues.`,
  },
  {
    title: '5.  Keyword Usage & Internal Linking Checker',
    description: `Following the content assessment, we conduct a thorough examination of keyword usage. We meticulously evaluate whether keywords are appropriately integrated, avoiding overstuffing and ensuring they align with their intended intent. We also verify the effectiveness of internal linking, a critical factor for improving website navigation and establishing a coherent information structure. This in-depth analysis encompasses all web content, blog posts, and product descriptions, aiming to identify opportunities for enhancing on-page SEO.`,
  },
  {
    title: '6. Backlink Review Checker',
    description: `Furthermore, we meticulously assess the website's backlink profile to gauge the strength and relevance of these links. We utilize various tools to evaluate the spam score associated with each backlink. This is a critical step to ascertain the quality and health of the links pointing to your website. It's essential to ensure that your backlinks are not only influential but also free from any harmful or questionable attributes, as low-quality links can have a detrimental impact on your website's SEO performance rather than enhancing it.`,
  },


];


export const methodData = [
  {
    number: 1,
    title: "researching",
    para: "When you choose ROZISOFT for SEO help, we'll first study your business and your goals. We'll have a meeting with your project team to figure out the important things to measure in your project. After this, we'll know what you want, and we can make a strategy that fits your goals.",
  },
  {
    number: 2,
    title: "Analyzing",
    para: "In the next phase, we start by looking at your website's past performance, like how many people visit, the words that help you appear on search engines, and links from other websites. We also check out your competitors to see what they're doing. We use special SEO tools and Google's tools like Analytics and Webmaster to come up with a plan just for you that will work well over time.",
  },
  {
    number: 3,
    title: "Planning",
    para: "Once we figure out where your business needs help with marketing, we'll create a special plan for you, working closely with you. This plan will be designed to boost your website's ranking so that you can get more visitors without having to pay for ads. In the first 30-60 days, our SEO experts will focus on fixing the most important things on your website to make sure our plan works well.",
  },
  {
    number: 4,
    title: "Executing",
    para: "In this phase, we put the SEO plan we made into action. We make your website better by fixing how it's set up, using the right words on your pages, and adding some important tags. We also use social media and online communities to make your website more visible on search engines.",
  },
  {
    number: 5,
    title: "Monitoring",
    para: "When you begin working with ROZISOFT, the first step is to set up a tracking system on your website. We do this by connecting Google Analytics and Google Search Console. This helps us check how well our online SEO efforts are doing, like how many people visit your site, how often they click on it, and how many inquiries you receive. We also track specific events, goals, and e-commerce activities to understand where your inquiries are coming from.",
  },
  {
    number: 6,
    title: "Reporting",
    para: "At the end of each month, our SEO experts to create a detailed report. This report shows how well we're doing with our online SEO plan, including things like how many people are visiting your site, which keywords are doing well, and how many inquiries you're getting. Plus, our Seo experts are here to help you and will stay in touch every month to let you know how things are going.",
  },
];

export const seoServiceData = [
  "Website SEO Audit",
  "Keyword Research",
  "On-Page Optimization",
  "Title tag optimization",
  "Meta Description optimization",
  "Header Tag Optimization",
  "Image Optimization",
  "Internal Link Optimization",
  "URL Optimization",
  "Content Creation & Optimization",
  "Blog Content Creation & Optimization",
  "Guest Posting",
  "Duplicate Content Analysis",
  "LSI keywords Implementation",
  "Tracking",
  "Competitor Analysis",
  "Dedicated Project Management Team",
  "Voice Search Optimization",
  "Sitemap Integration  ",
  "Monthly Reporting & Analysis",
  "Monthly Strategy Review  ",
  "Schema Markup Implementation",
  "Mobile Optimization",
  "Page Speed Optimization",
  "Google Analytics Setup and Tracking",
  "Search Console Setup and Tracking",
  "Local Business Directory Listings",
  "Link Building",
  "Social Bookmarking",
  "Google My Business Optimization",
];
export const faqs = [
  {
    question: "How does seo work?",
    answer: `Search Engine Optimization (SEO) is a strategy for increasing a website's traffic via organic search results. When you enlist professional SEO services, you can significantly boost your website's visibility and attract more traffic and leads. SEO helps users on the internet find the most relevant results for their queries. Search engines assess the intent behind user searches, consider their language and location, and rank websites that offer the most value. SEO services allow you to optimize your site for Google's search engine crawler to better understand your content on the search engine results pages (SERPs). Google gathers extensive data from web pages, and through indexing and crawling, it makes this information accessible. The structure and quality of your website's SEO services play a crucial role in determining how your content is indexed and, ultimately, how well it ranks when people search for your service.`,
  },
  {
    question: "How do I improve my website authority?",
    answer: `The credibility of your website hinges on the effectiveness of your off-page Link Building efforts. When your website garners reputable and high-quality mentions from other websites, which are essentially votes of confidence, it signifies your legitimacy as a business`,
  },
  {
    question: "Which part of seo I should work first?",
    answer: `SEO is a long-term strategy that has a lot of moving parts.Your website's on-page structure must be clear and load quickly. The content plays a major role in SEO, probably the most important role, then comes the right keyword research and proper integration.`,
  },
  {
    question: "What is the roi of seo?",
    answer: `The SEO ROI may take 4 to 5 months, at a minimum, for SEO efforts to become effective and for your website to rank on Google. Although SEO requires time to deliver a substantial return on investment, it's a cost-effective marketing method, usually involving only service charges with no additional payments to search engines.`,
  },
  {
    question: "What is better seo or ppc?",
    answer: `SEO and PPC offer distinct advantages. SEO is a low-cost, long-term strategy that fosters organic growth. PPC, on the other hand, is a rapid, high-impact approach with precise audience targeting, but it typically requires a more significant investment.`,
  },
  {
    question: "What is keyword research?",
    answer: `Keyword research involves investigating the terms and phrases people use when searching on Google for products or services similar to what your website offers. Our agency conducts comprehensive keyword research, compiling a list of search terms, including their monthly search volume and ranking difficulty.`,
  },
  {
    question: "Where is Pakistan do you provide seo services?",
    answer: `We offer SEO services in Pakistan and worldwide.`,
  },
];
// Seo Data Ends Here

// SMM Data Starts Here
export const smmStepData = [
  {
    icon: <i class="fa-brands fa-facebook"></i>,
    title: "Facebook Marketing",
    para: "We know how to optimize your Facebook content to reach a massive audience. Boost your visibility on Facebook and reach more potential customers with our Facebook SEO strategies.",
  },
  {
    icon: <i class="fa-brands fa-square-instagram"></i>,
    title: "Instagram Marketing",
    para: "Instagram is a great tool for start-ups to increase brand awareness and reach a broader audience with its visual platform. Our expertise can help you improve your Instagram content to boost your reach and website traffic.",
  },
  {
    icon: <i class="fa-brands fa-square-x-twitter"></i>,
    title: "Twitter Marketing",
    para: "Our Twitter marketing services help businesses harness the power of concise communication on Twitter. With millions of users on the platform, you can connect with top brands, celebrities, and athletes, all within the 280-character limit. Say more with less and leave a lasting impression on Twitter.",
  },
  {
    icon: <i class="fa-brands fa-linkedin"></i>,
    title: "LinkedIn Marketing",
    para: "LinkedIn is a potent platform for businesses of all sizes. It's a place to connect with potential customers, partners, and employees. Our LinkedIn marketing services can help you run effective campaigns that generate leads.",
  },
  {
    icon: <i class="fa-brands fa-square-pinterest"></i>,
    title: "Pinterest Marketing",
    para: "Pinterest is a valuable platform for businesses. With over 450 million active users seeking inspiration and ideas, our tested Pinterest campaigns will help you reach your target audience and grow your business.",
  },
  {
    icon: <i class="fa-brands fa-medium"></i>,
    title: "Medium Marketing",
    para: "Medium is the go-to platform for sharing written content and an excellent place for businesses to connect with a broader audience, build relationships with potential customers, and generate leads. At ROZISOFT, our team of experts can help you create and manage a successful Medium marketing campaign.",
  },
];

export const methodDataSmm = [
  {
    number: 1,
    title: "Research",
    para: "We kickstart the journey by conducting thorough research for your brand and business. This groundwork paves the way for a well-informed social media marketing strategy tailored to your needs",
  },
  {
    number: 2,
    title: "Moment Marketing",
    para: "Ever seen a brand seize the opportunity to promote itself during a sudden event or trending topic? Think of when an Olympic athlete wins gold and brands swiftly jump on the bandwagon. That's what we call moment marketing—the art of capturing those timely opportunities.",
  },
  {
    number: 3,
    title: "Ad Management",
    para: "We craft custom ad campaigns precisely targeting your ideal audience. Using a range of methods, such as age, interests, and hobbies, we ensure that your ads reach the individuals most likely to be interested in your business.",
  },
  {
    number: 4,
    title: "Meme Marketing",
    para: "A decade ago, memes were just starting to gain traction. Now, they're everywhere. Memes have become the common language of social media, a means for people to connect and share experiences. They are a powerful tool for uniting people, conveying ideas, and making an impact. Memes have proven to be an effective way to promote your products.",
  },
];

export const smmPara = [
  "Marketing is more than just putting up ads and hoping for the best. It needs a systematic approach using the right techniques to get good results. Billboards don't catch much attention these days, but platforms like Facebook, Twitter, and Instagram offer great opportunities for effective marketing.",
  "At ROZISOFT, we have social media marketing experts who've tested various strategies. We use SEO, PPC, content marketing, and more to create a recipe for success for your brand. With years of experience and a strong commitment to our clients, we're a top Social Media Marketing company in Pakistan.",
  "Choose us for a great Social Media Marketing plan that gets results. Since 90% of Pakistanis are on social media, there are millions of potential customers who can become loyal to your business. Using our SEO strategies, we can direct a big part of this traffic to your business, boosting your online presence and growth.",
  "Social media marketing, or SMM, is a powerful tool for businesses of all sizes. In Pakistan, ROZISOFT is a top social media marketing agency that can help you reach your business goals. Our methods have consistently delivered impressive results, and we're confident you'll be amazed by what we can do for your business.",
];

export const smmParaTwo = [
  "When we discuss Social Media Marketing (SMM), some might think that simply posting a few ads on Facebook will do the trick. However, in reality, SMM involves a well-thought-out strategy that focuses on specific keywords, a target audience, and choosing the right platform. At ROZISOFT, our marketing experts understand that each brand is unique. That's why we work closely with our clients to create a strategy that produces the best results",
  "So, what does ROZISOFT provide as your Social Media Marketing partner? Here's what we prioritize:",
];

export const faqsSmm = [
  {
    question: "How does social media work?",
    answer: `Social media marketing helps businesses connect with current customers and attract new ones, all while showcasing their culture, mission, and tone. At ROZISOFT, our main goal is to boost your brand's recognition and online presence across social platforms, resulting in increased sales and a better return on investment (ROI).`,
  },
  {
    question: "What Occurs in the Process of Social Media Marketing?",
    answer: `Social media platforms like Facebook, YouTube, and Twitter are immensely popular and easily accessible to anyone at no cost. Consequently, millions of active users frequent these sites, providing business owners with the opportunity to enhance brand awareness and engage with their target audience. Furthermore, social media platforms offer relatively cost-effective avenues for running marketing campaigns, leveling the playing field for organizations of varying sizes.
    
    Social media marketing campaigns typically revolve around the creation of unique content that captures attention and sparks conversations. Such content not only generates interest but also motivates users to share it with their social networks. As the content spreads from one user to another, it garners attention not just for the content itself but also for the creator behind it.
    `,
  },
  {
    question: "Why is social media important for your company?",
    answer: `Undoubtedly, social media is here to stay, with its capacity to build communities quickly. Hence, it's no surprise that numerous organizations have shifted their marketing efforts online. Today, businesses and organizations can pinpoint their target audience, foster community building, and establish relationships and communication with customers and clients.`,
  },
  {
    question: "How can we assist you with social media marketing?",
    answer: `Social media marketing campaigns are meticulously planned online marketing strategies that assist businesses and organizations in effortlessly disseminating their marketing messages across various social media platforms. We will devise and launch social media marketing campaigns centered around your company, brand, or website, facilitating the creation of an online community on platforms such as Facebook, YouTube, and Twitter. Through our creative marketing campaigns, you will witness how we employ diverse strategies to help you engage, connect with, and interact with the vast user base on these social sites. Our company has developed interactive marketing campaigns, including contests and giveaways, that leverage the viral features of social sites to rapidly disseminate marketing messages`,
  },
];

export const mainData = [
  {
    title: "Building Brand Awareness",
    para: "Establishing visibility among your desired audience is vital for attracting the right leads. Our experts ensure that your campaigns target the ideal audience for your business. By creating brand awareness, we increase the chances of converting these leads into valuable clients.",
  },
  {
    title: "Effective Engagement",
    para: "Attention is the currency in the realm of Social Media Platforms. To succeed in the social media game, capturing and maintaining your audience's attention is crucial. Our strength lies in crafting strategies that engage your audience effectively, sparking meaningful interactions and building strong connections.",
  },
  {
    title: "Boosting Website Traffic",
    para: "Getting people to visit your website is the initial step toward acquiring clients for your business. ROZISOFT works to optimize your website with the right keywords to attract organic and targeted traffic. This increased traffic has the potential to become long-term customers for your business. Additionally, it offers benefits beyond website visitors, as many can also become valuable social media followers. It's a win-win situation, expanding your online presence and fostering a loyal customer base.",
  },
];
// SMM Data Ends Here

// Web Development Data Starts Here
export const webPara = [
  "In today's digital age, as nearly every industry embraces digitization, establishing a robust online presence is pivotal for business success. If you haven't created a website yet, you're missing out on valuable opportunities to connect with a global audience. Think of it as expanding your business into the virtual realm. This is where ROZISOFT, a leading website development agency in Pakistan, comes into play.",
  "ROZISOFT has assisted numerous businesses in cultivating a standout online presence by crafting outstanding websites. With us, you won't receive a one-size-fits-all solution. We understand that every client is unique, with distinct expectations for their website. We take the time to listen and understand your needs, and then work diligently to deliver on them, often exceeding expectations!",
  "Our services extend beyond businesses seeking new websites. If your current website is sluggish, lacks aesthetic appeal, contains irrelevant information, or isn't achieving desired results, don't hesitate to reach out to us. We possess expertise in website design and development, capable of revitalizing your website's appearance and ensuring complete SEO optimization.",
  "Website design plays a crucial role, significantly influencing user experience and conversion rates. Prioritizing the User Interface (UI) and User Experience (UX) during website design and development is essential. Creating a visually appealing and user-friendly website is paramount in engaging customers and driving sales. A website with enhanced UI/UX serves as a gateway to engage potential customers and boost conversions.",
];

export const webStepData = [
  {
    icon: <i class="fa-solid fa-window-maximize"></i>,
    title: "Static Web Designing",
    para: `Rozisoft, a Pakistani web design company, is widely recognized for its outstanding web design services and cutting-edge digital marketing solutions. Our team of talented professionals specializes in crafting static websites featuring unique and creative designs customized to suit your specific industry. This is especially beneficial for small businesses seeking to establish a robust online presence.

`,
  },
  {
    icon: <i class="fa-solid fa-gear"></i>,
    title: "Custom Web Designing",
    para: `At Rozisoft, our client-centric approach defines us as the top web design company. We've streamlined web development, offering clients the simplicity of customizing their websites and making necessary changes whenever they need. Our role is to guide clients in making informed choices and narrowing down the options that best align with their goals.
`,
  },
  {
    icon: <i class="fa-solid fa-cart-shopping"></i>,
    title: "e-commerce Web Designing",
    para: `E-commerce websites simplify the process of selling products online, offering a user-friendly interface and seamless transactions. These websites are meticulously designed to provide comprehensive product information, ensure secure transactions, and effectively promote businesses on a global scale. Our services are dedicated to helping you establish and improve your online store using cutting-edge technologies.

`,
  },
  {
    icon:<i class="fa-solid fa-mobile"></i>,
    title: "Responsive Design",
    para: `At Rozisoft, we meticulously inspect all web pages to guarantee the delivery of a polished product that is responsive on all devices, optimized for web page speed, complies with core web vitals, and operates seamlessly.
`,
  },
  {
    icon: <i class="fa-solid fa-code"></i>,
    title: "Dynamic Web Designing",
    para: `Websites can be broadly classified into two main categories: Static and Dynamic. A Dynamic website stands out because its content is easily changeable and manageable. Dynamic Websites offer a world of possibilities, providing an interactive and user-friendly platform for visitors.
`,
  },
  {
    icon: <i class="fa-solid fa-object-group"></i>,
    title: "Website re-design",
    para: `Website Redesigning is a necessary process for various reasons, such as adding or removing content and keeping it up to date. In today's fast-paced world, with constantly changing markets, expanding businesses, and the emergence of new technologies, Website Redesigning is essential.

`,
  },
];

export const methodDataWeb = [
  {
    number: 1,
    title: "Shopping Cart",
    para: "Adding a shopping cart and checkout feature to your e-commerce website, whether it's Shopify, Woo Commerce, or WordPress, is a breeze with our solution.",
  },
  {
    number: 2,
    title: "Payment Gateway",
    para: "Seamlessly integrating various payment gateways into your responsive web design is essential for collecting payments from anywhere in the world. At ROZISOFT, we can assist you in integrating different payment gateways into your responsive web design.",
  },
  {
    number: 3,
    title: "Inventory Management",
    para: "ROZISOFT has the expertise to design and develop a comprehensive inventory management system for your website, making it effortless to keep tabs on all your inventory.",
  },
  {
    number: 4,
    title: "Bulk Product Import",
    para: "We can also assist you with the bulk product import feature, allowing you to swiftly add all your new products without any hassle. This feature proves invaluable for businesses with a sizable product inventory, saving time and effort.",
  },
];

export const webParaTwo = [
  "As technology continues to advance daily, websites have become an indispensable asset for your brand's marketing and promotional solutions. If your website isn't attracting a growing number of visitors, it won't contribute to your business's growth.",
  "When you feel that your website isn't delivering the desired returns, it may be time for a change or a fresh start. ROZISOFT can craft an innovative, SEO-friendly website that targets specific keywords and expands your audience base",
  "The initial impression made on a visitor is pivotal; it can either seal the deal or deter them within the first few minutes. Ensuring a positive impression from the outset is crucial, setting the stage for successful interactions and improving click-through rates—a critical ranking factor. Our website development team comprehends the significance of those initial moments. We ensure a flawless and engaging visitor experience by prioritizing interactive user interfaces and optimizing loading speed. Our unique approach sets us apart from other web design companies in Pakistan.",
];

export const webMain = [
  {
    title: "Responsive Web Design & Development",
    para: "Ensuring your website functions seamlessly on all devices—mobiles, tablets, laptops, and desktops.",
  },
  {
    title: "SEO-Friendly Web Designs",
    para: "Providing your online business in Pakistan with a competitive edge over rivals in search engine rankings",
  },
  {
    title: "Web Content",
    para: "Inclusive of SEO-friendly web content, so you receive a comprehensive package.",
  },
  {
    title: "Affordable Web Development and Design Packages",
    para: `Tailored to various website needs in Pakistan

    When you feel that your website isn't delivering the desired returns, it may be time for a change or a fresh start. ROZISOFT can craft an innovative, SEO-friendly website that targets specific keywords and expands your audience base. 
    `,
  },
];

export const faqsWeb = [
  {
    question: "How much does its cost for web design and development?",
    answer: `The cost of website design and development varies from client to client, contingent upon their specific requirements. Each content management system (CMS) demands distinct efforts and carries associated costs. Additionally, individual clients have unique preferences for their website, further contributing to the variability in costs.`,
  },
  {
    question: "What are the benefits of hiring our web development agency?",
    answer: `ROZISOFT, a web development company, offers a range of benefits including website design, mobile optimization, and content creation. Our team, comprising web designers, content writers, graphic designers, and SEO specialists, works together to craft a customer-centric brand identity. Our focus is on enhancing search rankings through compelling content, site optimization for speed, and visually appealing design. At ROZISOFT, your online success takes precedence.
    `,
  },
  {
    question:
      "What are the standout features rozisoft offers in web development to customers?",
    answer: `ROZISOFT distinguishes itself with remarkable features, which encompass custom website design, SEO-optimized content, responsive design, utilization of cutting-edge technologies, and an unwavering commitment to revisions. Our customer-centric approach at ROZISOFT is dedicated to enhancing relevant traffic and nurturing the growth of your business.`,
  },
];

// Web Development Data Ends Here

// Graphic Design Data Starts Here
export const DesignPara = [
  "Graphic Design is the art of creative expression through visual mediums. Not all designs are equal, and some styles find a niche in a crowded marketplace. Graphic design enhances brand identity and expression. ROZISOFT offers services from basic logo creation to advanced UI and chromatic design. Whether you need premium quality and affordable graphic design, our professional team tailors creative designs to your needs. We create innovative corporate designs, logos, and templates, enhancing your business, brand, or product's appeal. Our experienced graphic designers transform imagination into reality, attracting more people to your business. Design plays a crucial role in any business, and we're here to help you stand out.",
  "At ROZISOFT, we assemble a talented team of graphic designers, visual artists, and content creators. We craft designs with a passion for conveying a brand's essence, ensuring instant brand recognition and a positive business reputation.",
  "Our graphic design team consists of carefully selected industry experts, fueled by a creative fire that permeates every project. Collaborating toward the common goal of client satisfaction, our team creates lasting impressions that resonate with viewers.",
];

export const designStepData = [
  {
    icon: <i class="fa-brands fa-pied-piper-alt"></i>,
    title: "Logo Design & Branding",
    para: `Your logo is just one piece of your brand, but it's very important. With our graphic design services, we can design a logo that fits perfectly with your brand's identity and looks great in many different situations.

    ROZISOFT Graphics will create a brand identity that communicates your message and attracts your ideal customers. Our graphic design services will provide you with great-looking graphics and materials you can use in lots of different ways.
    

`,
  },
  {
    icon: <i class="fa-solid fa-rectangle-ad"></i>,
    title: "Promotion Design",
    para: `ROZISOFT Graphics has more than 8 years of experience designing for print. We can create attractive printed materials like business cards, brochures, newsletters, posters, and menus.

    We're also skilled at designing promotional signs and large-format items used for displays at events or in your business. Whether it's indoors or outdoors, ROZISOFT Graphics can make sure your signs get attention.
    
`,
  },
  {
    icon: <i class="fa-solid fa-font"></i>,
    title: "Monograms",
    para: `Monogram logos, also known as letter marks, are a type of logo that incorporates words or initials of a business. These logos are made up of only typography and generally range from two to three letters. Famous examples of monogram logos include HBO, NASA, and KFC. Monogram logos are memorable and have a clean, crisp, and often classy look.
`,
  },
  {
    icon: <i class="fa-solid fa-bezier-curve"></i>,
    title: "WEB GRAPHICS",
    list: [
      "Banner Design",
      "Icon Sets",
      "Craigslist Ads",
      "Custom Ads",
      "Custom Graphics",
      "E-mail Templates",
    ],
  },
  {
    icon: <i class="fa-solid fa-print"></i>,
    title: "PRINT DESIGN",
    list: [
      "Stationary",
      "Brochures",
      "Business Cards",
      "Magazine Layouts",
      "Pens, Mugs, Key Chains etc.",
      "Custom Print Design",
    ],
  },
  {
    icon: <i class="fa-solid fa-copyright"></i>,
    title: "LOGO AND BRANDING DESIGN",
    list: [
      "Company Logos",
      "Complete Branding Design Packages",
      "Custom Request Welcomed",
    ],
  },
];

export const designParaTwo = [
  "Maximize your marketing impact with professional graphic design and brand consistency.",
  "Good graphic design does more than make words easy to read. It can turn your business logo into a brand that looks professional and attracts customers. The way you show your message is just as important as the words themselves. For example, you wouldn't use the same design to attract kids and older people, would you? Of course not. That's why graphic design matters.",
  "It's how you share your brand, and you want it to look the same everywhere. Being consistent helps build trust with your current customers and makes you look professional to new ones. On social media and in online marketing, being consistent helps people know and remember your brand, setting it apart from others.",
];

export const faqsGraphic = [
  {
    question: "How does logo design and branding work?",
    answer: `Your logo is like your business's face; it's a crucial part of your brand. The colors, style, fonts, and elements in your logo show people what you stand for and what makes you unique. To craft the ideal logo for your needs, we:

    Study your brand.
    Research your industry.
    Consider where and how your logo will be used.
    Sketch out 2-3 logo concepts.
    Create digital versions of your logo.
    Work with your feedback to make it just right.
    `,
  },
];

// Graphic Design Data Ends Here


// PPC Data Starts Here
export const pointsPpc = [
  {
    title: 'Get Discovered Today',
    description: 'Allow us to establish your meticulously optimized PPC campaign today, ensuring that your brand is discovered by your target audience in no time.',
  },
  {
    title: 'Achieve Maximum ROI',
    description: 'At ROZISOFT, our team of PPC experts is committed to delivering an impressive ROI of up to 20%.',
  },
  {
    title: 'Reconnect with Your Potential Audience',
    description: `Leveraging PPC, the quickest and most efficient method, we help you re-engage your potential Audience.`,
  },
];

export const ppcParaTwo = [
  "Pay-per-click (PPC) is a marketing method where you can showcase your branded ads on search engines like Google. PPC, such as Google Ads, enables your website to quickly attain a top position on the first page of Google, unlike SEO, which is a continuous and time-consuming process. If you're a new brand with a marketing budget, PPC ads can swiftly attract customers. ROZISOFT offers comprehensive PPC services worldwide, including landing page creation, PPC implementation, and bid adjustments for optimal results.",
 
];

export const methodDataPpc = [
  {
    number: 1,
    title: "Keyword Research",
    para: "Careful exploration to identify the most effective keywords for your campaign.",
  },
  {
    number: 2,
    title: "Campaign Strategy and Planning",
    para: "Crafting a tailored strategy for your campaign to ensure optimal results.",
  },
  {
    number: 3,
    title: "Ad Creation",
    para: "Designing engaging and compelling advertisements tailored to your campaign's goals",
  },
  {
    number: 4,
    title: "Landing Page Optimization",
    para: "Fine-tuning landing pages to enhance user experience and conversion rates.",
  },
  {
    number: 5,
    title: "Campaign Setup and Configuration",
    para: "Setting up the PPC campaign with precision and configuring all essential elements.",
  },
  {
    number: 6,
    title: "Ad Monitoring and Optimization",
    para: "Continuous tracking and refinement of your ads for peak performance.",
  },
  {
    number: 7,
    title: "A/B Testing",
    para: "Thorough testing of ad variations to discover the most effective approaches.",
  },
  {
    number: 8,
    title: "Performance Reporting",
    para: "Providing comprehensive and transparent reports on campaign performance.",
  },
  {
    number: 9,
    title: "Ongoing Management",
    para: "Continuous management and optimization to ensure your PPC campaign remains effective and aligned with your goals.",
  },
];
// PPC Data Ends Here

// Content Writing Data Starts Here
export const contentPara = [
  "Even the best websites can struggle to rank on Google if they lack valuable and fitting content. Your website should effectively convey its message to both online users and search engines, such as Google. Here at ROZISOFT, we recognize the significance of top-notch website content that's also optimized for SEO. Our team of expert website content writers in Pakistan is committed to providing comprehensive and SEO-friendly web content that captivates your audience and boosts your website's visibility in search results",
  "Creating content that ranks well is a complex task. It needs to appeal to both online users and search engines. What appeals to your audience? Ensure the information in your content is pertinent and aligns with the tone of your website. Keep in mind, having relevant and high-quality content on your website is crucial. Think of it like speaking to a group of students about retirement plans.",
  "Search engines are like robots, and they treat perfectly crafted content the same as mediocre content. To connect with search engines, we must ensure the content is optimized for them. It might sound like a lot of work, and it is. That's why, at ROZISOFT, we allow our clients to focus on their services while we communicate on their behalf, bringing in new customers from the digital world.",
];

export const contentStepData = [
  {
    icon: <i class="fa-solid fa-pen"></i>,
    title: "Product Descriptions",
    para: `Images alone no longer suffice to sell your products effectively! To promote your products or services successfully, you need engaging product descriptions that clarify what the product is, how it functions, and what it offers. Our team of expert writers can craft tailored product descriptions that will set you apart in the market.
`,
  },
  {
    icon: <i class="fa-solid fa-file"></i>,
    title: "Landing Pages",
    para: `Our web content writing experts in Pakistan can assist you in creating highly converting content for your landing pages. We understand your audience's needs and can create content that drives favorable results 
`,
  },
  {
    icon: <i class="fa-solid fa-mask"></i>,
    title: "Unique & Relevant Content",
    para: `Our professional web content writing services in Pakistan guarantee entirely unique and relevant content, free from grammatical errors. Our expert writers can create content that effectively communicates your business to your audience, engaging them through your content.
`,
  },
  {
    icon: <i class="fa-solid fa-newspaper"></i>,
    title: "Press Release",
   para:`Looking to promote your business? Consider using our press release writing services. Our in-house writers can produce high-quality content targeting either US or UK audiences, captivating your readers. We offer affordable press release writing services designed to enhance your business reputation while saving you time and money.`
  },
  {
    icon: <i class="fa-solid fa-magnifying-glass-chart"></i>,
    title: "Optimized Content",
   para:`Our SEO content writing services provide fully optimized content for search engine results pages, eliminating your worries about website ranking. Our expert writers blend quality writing skills with experience in creating content optimized for search engines.`
  },
  {
    icon: <i class="fa-solid fa-clock"></i>,
    title: "Delivery on time",
   para:`
   Punctuality is paramount at Rozisoft. We consistently deliver our services on time, providing you with quality results precisely when you need them. Your projects are our priority, and we ensure they stay on track, helping you meet your goals without unnecessary delays.`
  },
  
];

export const contentParaTwo = [
  "Effective website content is essential for conveying the right message to your target audience. Your website's homepage and other sections should be informative, distinctive, user-friendly, and optimized for search engines. Achieving this requires a unique skill set that strikes a balance between engaging content and informative delivery. Professional website content writers focus on providing information rather than emphasizing commercial aspects or product promotions.",
  "At ROZISOFT, our website content writing services in Pakistan set us apart. We are dedicated to delivering in-depth, concise, and accurate content that effectively connects with your intended audience. Our team of experienced and professional writers utilizes a diverse vocabulary and industry-specific terminology to promote your products or services online","Website content writers specialize in crafting content tailored for websites, with each site catering to a specific target audience requiring the most relevant information to attract business. Content should incorporate keywords aimed at enhancing a website's SEO. Content writing is closely related to SEO copywriting, and it's vital to choose topics and keywords with both in mind. Developing SEO content is crucial for helping your business appear in more relevant search results and driving increased traffic to your site.",
];
// Content Writing Data Ends Here

// Digital Marketing Data Starts Here
export const pointsDm = [
  {
    title: 'Brand Awareness',
    description: 'Our strategy involves crafting campaigns designed to reach your specific target audience, piquing their interest in your product or service and enhancing brand awareness.',
  },
  {
    title: 'Sales',
    description: 'Through a combination of social media and search engine techniques, we employ both paid and organic methods to amplify lead generation and drive increased sales for your business.',
  },
  {
    title: 'Growth',
    description: `As we roll out tailored campaigns for your products and services, you'll experience consistent brand growth, fueling the expansion of your market presence.`,
  },
  {
    title: 'Great Exposure',
    description: `We provide our clients with innovative concepts to garner the market recognition and exposure they rightfully deserve, ensuring they receive outstanding visibility.`,
  },
];
export const dmStepData = [
  {
    icon: <i class="fa-solid fa-traffic-light"></i>,
    title: "Traffic Generation & Coversions",
    para: `Traffic Generation & Coversions
    Our campaigns are created to work on both unpaid and paid platforms to attract more customers and bring in new visitors consistently. We ensure that potential customers follow a well-structured path to become dedicated, repeat customers.
    `,
  },
  {
    icon: <i class="fa-solid fa-gears"></i>,
    title: "Retargeting & Conversion Rate Optimization",
    para: `We study how visitors behave on our site to find any weaknesses in our campaign. Then, we focus our efforts on bringing back the audience who left without buying anything, all in an effort to boost our conversion rate.`,
  },
  {
    icon: <i class="fa-solid fa-clipboard"></i>,
    title: "Content Marketing",
    para: `Content takes on various forms, whether it's a blog post, image, video, or podcast. Regardless of the format, it must be designed for ease of consumption and must provide value to your audience. But the journey doesn't stop there. Exceptional content, like outstanding products, must be strategically positioned to ensure it reaches the right audience; otherwise, it might remain unnoticed indefinitely.
`,
  },
  {
    icon: <i class="fa-solid fa-arrow-pointer"></i>,
    title: "PPC Marketing (Pay-Per-Click)",
   para:`Pay-per-click (PPC) is a versatile marketing medium that enables you to showcase your branded ads on platforms like Google and other search engines. Unlike SEO, PPC allows you to swiftly secure the top position on Google's first page. It's especially effective for new brands with ample marketing budgets, as it can swiftly attract customers. Even if your brand is just getting started, PPC ads can be created and executed effectively.`
  },
  {
    icon: <i class="fa-solid fa-chart-pie"></i>,
    title: "Digital Marketing Strategy",
   para:`First, before we start anything, we thoroughly examine your brand and where it stands. Then, we create a unique digital marketing plan that's tailored to attract the right potential customers, generate leads, and boost sales`
  },
  {
    icon: <i class="fa-solid fa-flag"></i>,
    title: "Campaign Setup",
   para:`Once we've chosen which marketing channels to use and who our target audience is, it's time to create campaigns that are precise and affordable. We always aim to stay within the budget and avoid overspending.`
  },
  
];

// Digital Marketing Data Ends Here

// Link Building Data Starts here
export const lbStepData = [
  {
    icon: <i class="fa-solid fa-bullseye"></i>,
    title: "Keyword Strategy",
    para: ` We use specific keywords as anchor texts in link building. Our experts do detailed research to create a smart keyword plan, avoiding overuse and getting quality backlinks. This helps us create content that ranks high in search results and attracts good websites to link to us.
    `,
  },
  {
    icon: <i class="fa-regular fa-chart-bar"></i>,
    title: "Competitor Analysis",
    para: `We study what links your competitors have to find opportunities for your site. We group these links based on industry and how easy they are to get. Then, we use this data to make your link-building plan.`,
  },
  {
    icon: <i class="fa-solid fa-link"></i>,
    title: "Backlink Audits",
    para: `Having good links is important for bringing in quality visitors. We check your links carefully to find any that might get you in trouble with Google. We make a list of where your links come from, check their quality, and suggest which ones to remove.
`,
  },
  {
    icon: <i class="fa-solid fa-satellite-dish"></i>,
    title: "Outreach Service",
   para:`We keep in touch with the websites that link to us, building strong relationships with webmasters, bloggers, and others. We find our target audience and look for websites that are similar. We also check how well these websites do in search engines.`
  },
  {
    icon: <i class="fa-regular fa-paste"></i>,
    title: "Guest Posts",
   para:` Our team of content experts creates interesting and informative posts. We share these on websites where your potential audience hangs out. We also promote these posts on social media to bring in more visitors.`
  },
  {
    icon: <i class="fa-solid fa-user-pen"></i>,
    title: "Niche Edits",
   para:`We ask authority websites to add links to our content in their existing articles. We make sure these links are legitimate and earned fairly.`
  },
  {
    icon: <i class="fa-solid fa-copyright"></i>,
    title: "Brand Mentions",
   para:`We turn brand mentions into links, getting lots of new backlinks. We find places where your brand is mentioned but not linked, connect with the authors, and explain why they should link to your website. This helps us get high-quality backlinks and build long-term relationships.`
  },
  {
    icon: <i class="fa-solid fa-shield-halved"></i>,
    title: "Broken Link Recovery",
   para:`We replace broken links on other websites with links to your site. We find websites with broken links, create or change content that fits, and ask them to use our links instead.`
  },
  {
    icon: <i class="fa-solid fa-fire"></i>,
    title: "Sponsorship Campaign",
   para:`We connect your brand with local events and campaigns to reach your local audience. This also helps improve your brand's visibility and reach a wider audience.`
  },
];

export const lbParaTwo = [
  "Getting links from other websites is a really important part of SEO. To do it right, you need to get good links from reliable and trusted websites.The better these websites are, the more it helps your website show up in search results. Also, having more websites linking to yours means more people will come to your website.",
  "At Rozisoft, we use smart tools and strategies to look at your links and find good websites to link to yours. Our link-building service includes checking your links, looking at your content, comparing with your competitors, doing content marketing, and creating a plan just for you. We work closely with our SEO team to make sure we follow the rules and help your brand. You can trust us to give our very best to make your links work well."
];

export const methodDatalb = [
  {
    number: 1,
    title: "Detailed Website Analysis",
    para: "We go through your website to figure out which pages work best, where there are gaps in your content, find and fix broken links, and plan how to get more links from other sites. Analyzing your site also helps us understand who visits your pages and what they're interested in, which guides us in making content that's just for them. We use data to create link building strategies that bring in valuable referrals.",
  },
  {
    number: 2,
    title: "White Hat Link Building Methods",
    para: "We stay away from tricky link building tactics that can harm your site with Google penalties and hurt your search engine ranking. At Rozisoft, we use ethical link building methods and set clear goals to get good links from strong websites. We always check the quality of the websites that link to you to make sure they are trustworthy.",
  },
  {
    number: 3,
    title: "Planning Your Campaign",
    para: "From picking the right keywords to promoting your content and getting more links, we make sure every part of your link building plan is focused on smart goals. Our link building experts set your targets, create your content, research where to get links, and start link building campaigns. We plan these campaigns to get the best opportunities for good links.",
  },
  {
    number: 4,
    title: "Strategy Meeting",
    para: "Our link building experts make sure that all our link building packages meet your standards for quality. We work with our digital marketing experts and talk to your project managers to come up with link building methods that help your online growth. You can schedule a call with us to start your campaign.",
  },
  {
    number: 5,
    title: "Experienced Link Builders",
    para: "Rozisoft link building specialists have many years of experience in creating ethical link building solutions. Our team knows the rules set by search engines for building brand awareness and promoting content on the internet. Work with us and use link building methods approved by search engines.",
  },
  {
    number: 6,
    title: "Tailored Strategies for Clients",
    para: "We look at your target audience, what your brand is all about, and the links that point to your website to make sure your link building plan matches your goals. Our link building agency offers a six-month contract for our service, so you have time to see the results of our link building efforts. We also give you detailed reports about your campaign, showing how many links we got, how your ranking improved, and a summary of the links we got.",
  },
];
// Link Building Data Ends here